import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import React from "react";
import {
  Grid,
  LinearProgress,
  Paper,
  Typography,
  withStyles,
} from "material-ui";
import Button from "../../../components/button";
import { bool, func, shape, string } from "prop-types";
import compose from "recompose/compose";

const styles = (theme) => ({
  background: {
    background: theme.palette.primary.main,
    height: "100vh",
  },
  personApp: {
    position: "absolute",
    width: 374,
    zIndex: 1,
    bottom: 0,
    left: 20,
    "@media (max-width: 1600px)": {
      display: "none",
    },
  },
  cellphone: {
    position: "absolute",
    zIndex: 1,
    bottom: 0,
    right: 0,
    "@media (max-width: 1600px)": {
      display: "none",
    },
  },
  shadow: {
    width: "100%",
    position: "absolute",
    zIndex: 0,
    bottom: 0,
    "@media (max-width: 700px)": {
      display: "none",
    },
  },
  acceptedContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  titleStyle: {
    textAlign: "center",
    color: "#6c4af8",
    marginBottom: 0,
  },
  logo: {
    width: 312,
    paddingBottom: 32,
    "@media (max-width: 700px)": {
      width: 227,
      padding: "0 0 30px 0",
    },
  },
  loadingContainer: {
    height: 5,
  },
  paperContainer: {
    height: "calc(100vh - 211px)",
    minHeight: 360,
    maxWidth: 820,
    "@media (max-width: 700px)": {
      height: "calc(100vh - 152px)",
    },
  },
  container: {
    zIndex: 2,
    width: "100%",
    height: "100%",
  },
  termsContainer: {
    height: "calc(100% - 185px)",
    padding: "20px 2.5%",
    margin: "0 2.5%",
    overflowY: "auto",
    textAlign: "justify",
  },
  pageNumberContainer: {
    textAlign: "right",
    margin: "5px 2.5% 5px",
  },
  buttonContainer: {
    height: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  errorTerms: {
    color: "red",
  },
  error: {
    color: "red",
    marginLeft: 10,
  },
});

let gridElement;

const termsComponentProps = {
  title: "Términos y Condiciones",
  BodyComponent: TermsAndConditions,
  page: "1",
};

const privacyComponentProps = {
  title: "Política de Seguridad y Privacidad",
  BodyComponent: PrivacyPolicy,
  page: "2",
};

const getWAPhone = (countryCode) => {
  switch (countryCode) {
    case "es":
      return "34692520027";
    case "ar":
    default:
      return '5491162220115'
  }
};

const Terms = ({
  classes,
  code,
  countryCode,
  accepted,
  acceptedTC,
  acceptedPrivacy,
  loadingTerms,
  loadingAccept,
  disabledButton,
  enableButton,
  acceptTC,
  acceptPrivacy,
  error,
  errorTerms,
}) => {
  const onScrollEnds = (e) => {
    let element = e.target;
    if (
      element.scrollTop !== 0 &&
      element.scrollHeight - element.scrollTop === element.clientHeight
    ) {
      gridElement = element;
      enableButton();
    }
  };

  const onClick = () => {
    if (!acceptedTC) {
      acceptTC();
      // gridElement.scrollTo(0, 0)
    } else {
      acceptPrivacy(code);
    }
  };

  const waPhone = getWAPhone(countryCode);

  const continueToAgreement = () => {
    window.open(
      `https://wa.me/${waPhone}/?text=%C2%A1Listo%21%20Ya%20acept%C3%A9%20los%20TyC.%20Quiero%20seguir%20con%20el%20proceso`,
      "_blank"
    );
  };

  const renderMessage = (message, error = false) => {
    return (
      <div className={classes.acceptedContainer}>
        <Grid container spacing={0} justify="center">
          <Grid container item xs={12} className={classes.buttonContainer}>
            <Button disabled={error == true} onClick={continueToAgreement}>
              Continuar
            </Button>
          </Grid>
          <Grid container item xs={12} justify="center" spacing={15}>
            <Typography className={error ? classes.errorTerms : ""}>
              {message}
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderBody = () => {
    if (error) return renderMessage(error, true);
    if (errorTerms) return renderMessage(errorTerms, true);
    if (accepted)
      return renderMessage("Ya se han aceptado los Términos y Condiciones");
    if (acceptedPrivacy)
      return renderMessage("Términos y Condiciones aceptados. Gracias!");

    const { title, BodyComponent, page } = acceptedTC
      ? privacyComponentProps
      : termsComponentProps;

    return (
      <Paper className={classes.container}>
        <Grid item xs={12} className={classes.buttonContainer}>
          <Typography
            variant="title"
            component="h1"
            className={classes.titleStyle}
            paragraph={true}
          >
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.termsContainer}
          onScroll={onScrollEnds}
        >
          <BodyComponent countryCode={countryCode} />
        </Grid>
        <Grid item xs={12} className={classes.pageNumberContainer}>
          <Typography variant="body1" component="span">
            Página {page} de 2
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.buttonContainer}>
          <Button disabled={disabledButton || loadingAccept} onClick={onClick}>
            Acepto
          </Button>
          {error !== "" && (
            <Typography className={classes.error}>{error}</Typography>
          )}
        </Grid>
      </Paper>
    );
  };

  return (
    <Grid className={classes.background} container spacing={0} justify="center">
      <Grid item xs={12} className={classes.loadingContainer}>
        {(loadingTerms || loadingAccept) && <LinearProgress />}
      </Grid>
      <Grid
        container
        item
        xs={12}
        justify="center"
        alignItems="center"
        direction="column"
      >
        <img
          className={classes.logo}
          src="/assets/logo/newLogo.png"
          alt="Space Guru"
        />
      </Grid>
      {!loadingTerms && (
        <Grid container item xs={12} className={classes.paperContainer}>
          {renderBody()}
        </Grid>
      )}
      <img className={classes.personApp} src="/assets/personApp.png" />
      <img className={classes.cellphone} src="/assets/cellphone.png" />
      <img className={classes.shadow} src="/assets/shadow.svg" />
    </Grid>
  );
};

Terms.propTypes = {
  match: shape({
    params: shape({
      code: string,
    }).isRequired,
  }).isRequired,
  classes: shape({}),
  code: string.isRequired,
  countryCode: string.isRequired,
  accepted: bool.isRequired,
  acceptedTC: bool.isRequired,
  acceptedPrivacy: bool.isRequired,
  loadingTerms: bool.isRequired,
  loadingAccept: bool.isRequired,
  disabledButton: bool.isRequired,
  enableButton: func.isRequired,
  acceptTC: func.isRequired,
  verifyAcceptance: func.isRequired,
  acceptPrivacy: func.isRequired,
  errorTerms: string,
  error: string,
};

export default compose(withStyles(styles, { withTheme: true }))(Terms);



// WEBPACK FOOTER //
// ./src/sections/terms/components/Terms.js